import axios from 'axios';
var zoho = require("../../config/zoho");

var qs = require('qs');

export const list = async(params ) =>{

  //   const data = {
  //     client_id: zoho.ZOHO_CLIENT_ID,
  //     client_secret: zoho.ZOHO_CLIENT_SECRET,
  //     refresh_token: zoho.ZOHO_REFRESH_TOKEN,
  //     grant_type: "refresh_token"
  //   }
  //   try{
  //   res = await axios({
  //     method: "POST",
  //     url: zoho.ZOHO_URI_ACCOUNT+"oauth/v2/token", 
  //     params: data,
  //     headers: {
  //       "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  //       "Accept": "*/*",
  //       "Accept-Encoding":"gzip, deflate, br",
  //       "Connection": "keep-alive"
  //     }
  //   });
  // } catch(e) {
  //   console.log("E: ", e)
  // }
  var config = {
    method: 'get',
    url: 'https://zohoapi.nus.agency/users'
  };
  
  const res = await axios(config)


  return  res
}
